const SUPERADMIN_USER_SEARCH_LIMIT = "SUPERADMIN_USER_SEARCH_LIMIT"

const globals = {
    [SUPERADMIN_USER_SEARCH_LIMIT]: 0,
}

export default globals;